import React from "react"
import { useSelector } from "react-redux"

import { EDIT } from "const"
import { mtPackagesRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import Edit from "./edit"

const MtPackage = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    return userData.accountId === 1
        ? (
            <Switch>
                <Route
                    exact
                    path={mtPackagesRoute}
                    component={List}
                />
                <Route
                    path={`${mtPackagesRoute}/${EDIT}/:packageId`}
                    component={Edit}
                />
            </Switch>
        )
        : <AccessDenied />
}
export default MtPackage
